import axios, { AxiosError, AxiosResponse } from "axios";

// Types for the form data
export interface MailPayload {
  fname: string;
  lname: string;
  email: string;
  message: string;
}

// Build the payload for the internal enquiry email using Mailjet template ID
export function getEnquiryMailPayload({ fname, lname, email, message }: MailPayload) {
  const mailFrom = process.env.MAIL_FROM;
  const mailTo = process.env.MAIL_TO;
  const templateId = process.env.MJ_ENQUIRY_TEMPLATE_ID;
  return {
    Messages: [
      {
        From: {
          Email: mailFrom,
          Name: "Erom Studio Web",
        },
        To: [
          {
            Email: mailTo,
            Name: "Erom Studio Team",
          },
        ],
        Subject: "New Enquiry from Website",
        TemplateID: Number(templateId),
        TemplateLanguage: true,
        Variables: {
          fname,
          lname,
          email,
          message,
        },
      },
    ],
  };
}

// Build the payload for the client acknowledgement email using Mailjet template ID
export function getAcknowledgementMailPayload(mailTo: string, firstName: string, lastName: string) {
  const mailFrom = process.env.MAIL_FROM;
  const templateId = process.env.MJ_ACK_TEMPLATE_ID;
  return {
    Messages: [
      {
        From: {
          Email: mailFrom,
          Name: "Erom Studio Team",
        },
        To: [
          {
            Email: mailTo,
            Name: `${firstName} ${lastName}`,
          },
        ],
        Subject: "Thank you for reaching out to us",
        TemplateID: Number(templateId),
        TemplateLanguage: true,
        Variables: {
          fname: firstName,
        },
      },
    ],
  };
}

// Send email via Mailjet API
export async function sendMailjet(payload: any): Promise<number> {
  const MJ_APIKEY_PUBLIC = process.env.MJ_APIKEY_PUBLIC;
  const MJ_APIKEY_PRIVATE = process.env.MJ_APIKEY_PRIVATE;
  try {
    const response = (await axios.post(
      "https://api.mailjet.com/v3.1/send",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
        auth: {
          username: MJ_APIKEY_PUBLIC || "",
          password: MJ_APIKEY_PRIVATE || "",
        },
      }
    )) as AxiosResponse;
    return response.status;
  } catch (error) {
    if (error instanceof AxiosError) {
      if (error.response) {
        return error.response.status;
      } else {
        return 500;
      }
    } else {
      return 500;
    }
  }
}
